import { useQuery } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface DiyVideoData {
  title?: string;
  url?: string;
  description?: string;
  duration?: string;
  source?: string;
}

export interface DiyVideoResponse {
  success: boolean;
  data: DiyVideoData | null;
  message?: string;
}

interface EnrichmentParams {
  query: string;
  service_type: string;
  location: string;
  requirements?: string;
}

export const useGetDiyVideo = (
  params: EnrichmentParams,
  enabled = false
) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: ['diy-video', params.query, params.service_type, params.location],
    queryFn: async () =>
      handleApiCall<DiyVideoResponse, EnrichmentParams>(
        session,
        'POST',
        'vendor/enrichments/diy-video',
        params
      ),
    enabled,
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
};
